module.exports = {
      id: "switch-tyre-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite-99dfb162d59834e1e55e619b64a45f56.svg#switch-tyre",
      toString: function () {
        return this.url;
      }
    }